<template>
  <v-container class="align-center justify-center"
               style="height: 100%">
    <v-card flat color="transparent">
      <v-card-text>
        <v-form v-model="valid">
          <p class="center">
              {{ $t('Register.Your Name') }}
          </p>
          <v-text-field
            ref="formName"
            v-model="name"
            :rules="rules.name"
            required
            :placeholder="$t('Register.Your Name')"
            name="name"
            type="text"
            outlined
          />
          <div align="center">
            <p class="center">
              {{$t('NIE/NIF')}}
            </p>
            <v-text-field
              ref="formCif"
              v-model="cif"
              :rules="rules.cif"
              required
              :placeholder="$t('NIE/NIF')"
              name="cif"
              type="text"
              outlined
            />
          </div><div align="center">
            <p class="center">
                {{ $t('E-mail') }}
            </p>
            <v-text-field
              ref="formEmail"
              v-model="email"
              :placeholder="$t('E-mail')"
              :rules="rules.email"
              name="email"
              required
              type="text"
              outlined
            />
          </div><div align="center">
            <p class="center">
              {{$t('Password')}}
            </p>
            <v-text-field
              id="password"
              v-model="password"
              outlined
              :placeholder="$t('Password')"
              name="password"
              type="password"
              :rules="rules.password"
              required
              @keyup.enter="(valid && selected) ? onSubmit('keyboard') : ''"
            />
          </div>
        </v-form>
        <span style="color: #FFFFFF">
          {{ $t('Register.Use 6 characters with a mix of letters, numbers & symbols') }}
        </span><br>
      </v-card-text>
      <v-card-actions style="padding: 0px">
        <v-container style="padding: 0px">
          <v-row dense>
            <v-col cols="1">
              <v-checkbox v-model="selected" color="secondary" />
            </v-col>
            <v-col cols="10" style="align-self: center; font-size: small">
              <div style="justify-self: start; color: #FFFFFF">
                {{ $t('Register.By signing up, you agree to Byppay of Use & Privacy Policy') }}
                <span class="text-decoration-underline" style="cursor: pointer; color: #000000" @click="privacyPolicy">{{ $t('Register.Policy') }}</span>
              </div>
            </v-col>
          </v-row>
          <v-row dense>
            <v-btn color="primary" :loading="loadingRegister" depressed :disabled="!valid || !selected" small block @click="openPopup()">
              {{ $t('SIGN UP') }}
            </v-btn>
          </v-row>
          <v-dialog v-model="popupOpen" max-width="500px">
            <v-card>
              <v-card-title class="centered-title">
                {{ this.$t('Popup.verify') }}
              </v-card-title>
              <v-card-text>
                {{ this.$t('Register.Registered succesfully! Please check your email for the validation') }}
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" class="mx-auto" @click="closePopup">
                  Log in
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
      </v-card-actions><br>
      <div align="center" style="padding-top: 15px; color: #FFFFFF">
        <span>{{ $t('Register.Already signed up? ') }}</span>
        <span class="text-decoration-underline" style="cursor: pointer; color: #000000" @click="goLogin()">{{ $t('Log in') }}</span>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import AuthRepository from "../repositories/AuthRepository";
import Constants from "../../constants";
import LocalRepository from "../repositories/LocalRepository";

export default {
    name: "Register",
    data () {
        return {
            popupOpen: false,
            lazy: false,
            valid: false,
            name: '',
            surname: '',
            phone: '',
            email: '',
            address: '',
            cif: '',
            password: '',
            repeatPassword: '',
            country: 'Spain',
            loadingRegister: false,
            selected: false,
            items: [
                'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria',
                'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Bolivia', 'Bosnia and Herzegovina',
                'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Côte d\'Ivoire', 'Cabo Verde', 'Cambodia', 'Cameroon',
                'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica', 'Croatia', 'Cuba',
                'Cyprus', 'Czechia', 'Democratic Republic of the Congo', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador',
                'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'Gabon', 'Gambia',
                'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Hati', 'Holy See', 'Honduras',
                'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan',
                'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechetenstein', 'Lithuania',
                'Luxembourg', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico',
                'Micronesia', 'Moldova', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands',
                'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine State',
                'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis',
                'Saint Lucia', 'Saint Vincent and the Greandines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles',
                'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan', 'Spain', 'Sri Lanka',
                'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia',
                'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States of America', 'Uruguay', 'Uzbekistan',
                'Vanuatu', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
            ],
            rules: {
                name: [val => (val || '').length > 0 || this.$t('Error.This field is required')],
                surname: [val => (val || '').length > 0 || this.$t('Error.This field is required')],
                phone: [ v => /^(\+?[\d ]{9,}|)$/.test(v) || this.$t('The phone must be valid') ],
                email: [
                    v => !!v || this.$t('Error.The mail field is required'),
                    v => /.+@.+\..+/.test(v) || this.$t('The mail must be valid.')],
                cif: [
                    val => (val || '').length > 0 || this.$t('Error.This field is required'),
                    //v => /^[a-zA-Z0-9]{1}[0-9]{7}[a-zA-Z0-9]{1}$/.test(v) || this.$t('The CIF must be valid (Example formats: A12345678, 12345678B, C1234567D)')
                ],
                password: [
                    val => (val || '').length > 0 || this.$t('Error.This field is required'),
                    v => /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z-A-Z]).{6,}$/.test(v) || this.$t('The password must be valid')
                ]
            },
        };
    },
    created () {
        const cifLoginRepository = LocalRepository.get('cif-user-compensation');
        if (cifLoginRepository) {
            this.cif = cifLoginRepository;
        }
        const emailLoginUser = localStorage.getItem('email-user-compensation');
        if (emailLoginUser) {
            this.email = emailLoginUser;
        }
        if (this.$user) {
            this.name = this.$user.name;
            this.cif = this.$user.cif;
            this.email = this.$user.email;
        }
    },
    mounted () {
        const popupOpen = localStorage.getItem('popupOpen');
        if (popupOpen) {
            this.popupOpen = popupOpen === 'true';
        }
    },
    methods: {
        openPopup () {
            this.popupOpen = true;
            this.loadingRegister = true;
            AuthRepository.register(this.cif, this.email, this.password, this.name, localStorage.getItem('language'))
                .then((response) => {
                    if (response && response.data && response.data.token) {

                    }
                    this.loadingRegister = false;
                })
                .catch((err) => {
                    let missatge = "";
                    if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAVING_USER) {
                        missatge = this.$t('Register.ERROR: The user couldn\'t be saved');
                    } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAME_MAIL) {
                        missatge = this.$t('Regsiter.ERROR: E-mail already in use');
                    } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAME_CIF) {
                        missatge = this.$t('Register.ERROR: CiF already in use');
                    }
                    this.$root.$emit('show-snackbar', {message: missatge, color: "error"});
                    console.log("error: " + err.response.data.error);
                    this.loadingRegister = false;
                });
        },
        closePopup () {
            this.popupOpen = false;
            this.$router.push({name: 'Login', replace: true});
        },
        onSubmit () {
            this.popupOpen = true;
        },
        goLogin () {
            this.$router.push({name: 'Login', replace: true});
        },
        onCancel () {
            this.$router.push({name: 'LandingPage', replace: true});
        },
        goToTutorial () {
            if (this.$user)
                this.$router.push({name: 'Tutorial', params: {}, replace: true});
            else
                this.$root.$emit('show-snackbar', {message: this.$t('InvoiceChats.registeredError'), color: "error"});
        },
        privacyPolicy () {
            this.$router.push({name: 'PrivacyPolicy', replace: false});
        },
    }
};
</script>

<style >
  .v-text-field .v-input__control .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
    background-color: #FFFFFF;
    border-radius: 10px;
  }
  .right /deep/ input::placeholder {
    text-align: center;
  }
  .v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 4px !important;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px #F4F4F4 inset !important;
    margin: 8px;
    padding: 0px;
  }
  html,body {
    margin:    0 auto;
    height: 100%;
    /*overscroll-behavior-y: none;*/
    /*overflow-y: hidden;*/
  }
  body {
    width: 100%;
    height: 100%;
    position: fixed;
    /*overflow: hidden;*/
  }
  p {
    color: #FFFFFF;
    font-size: 15px
  }
  .center {
    display: flex;
    justify-content: center;
    align-items: center
  }
</style>
